import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export default function HouseholdLoginSetupRedirectPage() {
	const { token } = useParams();
	const navigate = useNavigate();

	useEffect(() => {
		if (!token) {
			navigate('/password-reset', { replace: true });
			return;
		}

		navigate(
			`/password-reset/update?reset_password_token=${encodeURIComponent(token)}&setup=1`,
			{ replace: true }
		);
	}, [navigate, token]);

	return null;
}
